const CONTACT_PHONE = "05015";
const CONTACT_EMAIL = "support@unifon.no";

const locations = [
  {
    idx: 1,
    title: "Kristiansand",
    address1: "Vestre Strandgate 27",
    address2: "4611 Kristiansand",
    location: { lat: 58.143993502578326, lng: 7.992161336452322 },
  },
  {
    idx: 2,
    title: "Oslo",
    address1: "Sandakerveien 140",
    address2: "0484 Oslo",
    location: { lat: 59.95241820610998, lng: 10.766689061565499 },
  },
  {
    idx: 3,
    title: "Bergen",
    address1: "Tverrveien 7",
    address2: "5160 Laksevåg",
    location: { lat: 60.383939855966865, lng: 5.311211521050216 },
  },
  {
    idx: 4,
    title: "Stavanger",
    address1: "Petroleumsveien 6",
    address2: "4033 Stavanger",
    location: { lat: 58.89238360460796, lng: 5.7217137086339775 },
  },
];
const defaultLocation = locations[2];

// Default "silver" map style
const mapStyle = [
  {
    elementType: "geometry",
    stylers: [{ color: "#f5f5f5" }],
  },
  {
    elementType: "labels.icon",
    stylers: [{ visibility: "off" }],
  },
  {
    elementType: "labels.text.fill",
    stylers: [{ color: "#616161" }],
  },
  {
    elementType: "labels.text.stroke",
    stylers: [{ color: "#f5f5f5" }],
  },
  {
    featureType: "administrative.land_parcel",
    elementType: "labels.text.fill",
    stylers: [{ color: "#bdbdbd" }],
  },
  {
    featureType: "poi",
    elementType: "geometry",
    stylers: [{ color: "#eeeeee" }],
  },
  {
    featureType: "poi",
    elementType: "labels.text.fill",
    stylers: [{ color: "#757575" }],
  },
  {
    featureType: "poi.park",
    elementType: "geometry",
    stylers: [{ color: "#e5e5e5" }],
  },
  {
    featureType: "poi.park",
    elementType: "labels.text.fill",
    stylers: [{ color: "#9e9e9e" }],
  },
  {
    featureType: "road",
    elementType: "geometry",
    stylers: [{ color: "#ffffff" }],
  },
  {
    featureType: "road.arterial",
    elementType: "labels.text.fill",
    stylers: [{ color: "#757575" }],
  },
  {
    featureType: "road.highway",
    elementType: "geometry",
    stylers: [{ color: "#dadada" }],
  },
  {
    featureType: "road.highway",
    elementType: "labels.text.fill",
    stylers: [{ color: "#616161" }],
  },
  {
    featureType: "road.local",
    elementType: "labels.text.fill",
    stylers: [{ color: "#9e9e9e" }],
  },
  {
    featureType: "transit.line",
    elementType: "geometry",
    stylers: [{ color: "#e5e5e5" }],
  },
  {
    featureType: "transit.station",
    elementType: "geometry",
    stylers: [{ color: "#eeeeee" }],
  },
  {
    featureType: "water",
    elementType: "geometry",
    stylers: [{ color: "#c9c9c9" }],
  },
  {
    featureType: "water",
    elementType: "labels.text.fill",
    stylers: [{ color: "#9e9e9e" }],
  },
];

const distanceBetweenTwoPoints = (x1, y1, x2, y2) => {
  return Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2));
};

const locationWithDistances = (mapCenter) => {
  const locationsWithDistance = locations
    .map((l) => {
      const dist = distanceBetweenTwoPoints(
        l.location.lat,
        l.location.lng,
        mapCenter.lat,
        mapCenter.lng
      );
      return {
        ...l,
        distance: dist,
        inview: dist < 0.15,
      };
    })
    .sort((a, b) => a.distance - b.distance);

  const closestLocation = locationsWithDistance[0];
  return { closestLocation, locationsWithDistance };
};

const createLocationButton = (map, item, color = "is-white") => {
  const controlButton = document.createElement("button");
  controlButton.textContent = item.title;
  controlButton.type = "button";
  controlButton.className = `u-btn map-btn ${color} data-idx-${item.idx}`;
  controlButton.addEventListener("click", () => {
    jQuery(".office-info-box-nav-row-wrapper").removeClass("active");
    map.setCenter(item.location);
    map.setZoom(14);
  });
  return controlButton;
};

const createLocationBoxContent = (item) =>
  [
    `<div class="office-name"><h2>${item.title}</h2></div>`,
    `<div class="office-location">`,
    `<div class="office-address"><span class="subtitle">Adresse</span><h2>${item.address1}<br>${item.address2}</h2></div>`,
    `<div class="office-contact"><span class="subtitle">Kontakt</span><h2>${CONTACT_PHONE}<br>${CONTACT_EMAIL}</h2></div>`,
    `</div>`,
  ].join("");

const createLocationBox = (item, isMobile) => {
  const mobileClass = isMobile ? "office-info-box-mobile" : "";
  const content = createLocationBoxContent(item);
  return jQuery(
    `<div class="office-info-box ${mobileClass}">${content}</div>`
  )[0];
};

const updateLocationBox = (item) =>
  jQuery(".office-info-box", "#kontakt-oss-map").html(
    createLocationBoxContent(item)
  );

const initMap = () => {
  if (document.getElementById("kontakt-oss-map") == null) return false;
  const map = new google.maps.Map(document.getElementById("kontakt-oss-map"), {
    zoom: 15,
    center: defaultLocation.location,
    disableDefaultUI: true,
    styles: mapStyle,
  });

  const locCtrlDiv = document.createElement("div");
  locCtrlDiv.style.padding = "25px";
  const locCtrlSmDiv = document.createElement("div");
  locCtrlSmDiv.style.padding = "8px";

  const navControlDivWrapper = document.createElement("div");
  navControlDivWrapper.style.padding = "15px";
  navControlDivWrapper.className = "office-info-box-nav-row-wrapper";
  const navControlDiv = document.createElement("div");
  navControlDiv.className = "office-info-box-nav-row";
  navControlDivWrapper.appendChild(navControlDiv);
  navControlDivWrapper.appendChild(
    jQuery(
      [
        '<div class="office-info-box-menu">',
        '<button type="button" class="u-btn map-btn is-white"><span class="dashicons dashicons-menu"></span></button>',
        "</div>",
      ].join("")
    )[0]
  );

  jQuery("button", navControlDivWrapper).bind("click", () => {
    jQuery(".office-info-box-nav-row-wrapper").addClass("active");
  });

  for (const item of locations) {
    const color = item.idx === defaultLocation.idx ? "is-blue" : "is-white";
    navControlDiv.appendChild(createLocationButton(map, item, color));

    new google.maps.Marker({
      map: map,
      icon: "/wp-content/themes/dreamtheme-child/src/img/mapmarker.svg",
      position: item.location,
    });
  }

  locCtrlDiv.appendChild(createLocationBox(defaultLocation, false));
  locCtrlSmDiv.appendChild(createLocationBox(defaultLocation, true));

  map.controls[google.maps.ControlPosition.TOP_LEFT].push(navControlDivWrapper);
  map.controls[google.maps.ControlPosition.TOP_RIGHT].push(locCtrlDiv);
  map.controls[google.maps.ControlPosition.BOTTOM_CENTER].push(locCtrlSmDiv);

  let changeTimeout;
  map.addListener("center_changed", () => {
    if (changeTimeout) clearTimeout(changeTimeout);
    changeTimeout = setTimeout(() => {
      const c = map.getCenter();
      const mapCenter = {
        lat: c.lat(),
        lng: c.lng(),
      };

      const { closestLocation } = locationWithDistances(mapCenter);
      if (closestLocation.inview) {
        jQuery(".u-btn.map-btn", "#kontakt-oss-map").removeClass("is-white");
        jQuery(".u-btn.map-btn", "#kontakt-oss-map").removeClass("is-blue");

        jQuery(
          `.u-btn.map-btn:not(.data-idx-${closestLocation.idx})`,
          "#kontakt-oss-map"
        ).addClass("is-white");
        jQuery(
          `.u-btn.map-btn.data-idx-${closestLocation.idx}`,
          "#kontakt-oss-map"
        ).addClass("is-blue");

        jQuery(".office-info-box", "#kontakt-oss-map").removeClass("hidden");
        updateLocationBox(closestLocation);
      } else {
        jQuery(".u-btn.map-btn", "#kontakt-oss-map").addClass("is-white");
        jQuery(".u-btn.map-btn", "#kontakt-oss-map").removeClass("is-blue");
        jQuery(".office-info-box", "#kontakt-oss-map").addClass("hidden");
      }
    }, 300);
  });
};

const setupGoogleMaps = () => {
  window.initMap = initMap;
};

export default setupGoogleMaps;
